import React, { createContext } from 'react';

export type UrlParamsContextType = {
  dataIndex: string;
  promotion_type: "specialPriceDetail" | "buyPresentDetail" | "groupBuyDetail";
  filterType: string;
  value: string;
  valueType?: 'string'|'number'
}

const UrlParamsContext = createContext<UrlParamsContextType | {}>([]);

export default UrlParamsContext;
